import { Link, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getMenuChangeReturnPath } from '../services/menuChange/menuChangeLinks';
import { primaryText } from '../styling/stylingHelper';
import { useAuth } from '../services/authentication/authContext';
import { canAccessMenuChangeDashboard } from '../services/accessManagement/accessManagement';

/**
 * Gates the Menu Change pages behind the per-account `menu_change_dashboard`
 * flag and, for staff, the Menu Change Dashboard permission. Redirects to the
 * dashboard when the account does not have the feature.
 */
export function MenuChangeRoute({ children }: { children: JSX.Element }) {
  const { backendUser, accountSettings } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (!canAccessMenuChangeDashboard(backendUser, accountSettings)) {
    if (getMenuChangeReturnPath(pathname)) return <div className={primaryText}><p role="alert">{t('menuChange.links.accessDenied')}</p><Link to="/dashboard" className="underline">{t('menuChange.links.back')}</Link></div>;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
